import { render } from "./func-area.vue?vue&type=template&id=3b2e96b8&scoped=true"
import script from "./func-area.vue?vue&type=script&lang=js"
export * from "./func-area.vue?vue&type=script&lang=js"

import "./func-area.vue?vue&type=style&index=0&id=3b2e96b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2e96b8"]])

export default __exports__